import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {LoadingComponent} from "./components/Loading";

// eslint-disable-next-line no-undef
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
			<React.StrictMode>
      	<App />
			</React.StrictMode>
      <ToastContainer />
        <LoadingComponent/>
    </Provider>
  </React.StrictMode>,
);
